/**
 * Created by jayasudha.selvaraj on 10/11/2016.
 */

quoteModule.directive('rvVehicleDefinition', function factory() {

    return {
        templateUrl: 'app/modules/quote/directives/rv-vehicle-definition-directive.html',
        replace: true,
        transclude: false,
        restrict: 'E',
        controller: 'rvVehicleDefinitionController',
        link: function(scope, element, attrs, vehicleDefCtrl) {
            vehicleDefCtrl.init( element );
        }
    };
});